import React, { useState } from 'react'
import { useEffect } from 'react';

export default function AvgProgress({ avg,...props}) {


    
    function BadgeClass(){
        
        if (avg <3){
          
            return "badge bg-red ";
        }
        else if (avg  <6) {
            return "badge bg-yellow ";
        }
        else if (avg  < 8) {
            return "badge bg-light-blue ";
        }
        else if (avg  <=10) {
            return "badge bg-green ";
        }

        
    }

    const ProgressClass=()=>{
        if (avg  < 3) {

            return "progress-bar progress-bar-danger";
        }
        else if (avg  < 6) {
            return "progress-bar progress-bar-yellow";
        }
        else if (avg  < 8) {
            return "progress-bar progress-bar-primary";
        }
        else if (avg  <= 10) {
            return "progress-bar  progress-bar-success";
        }
        
    }

    
    
    return (
        <tr className="bg-audience pointer" onClick={props?.onClick}  >
            <td style={{  paddingLeft:20 , height:37 }}>
                <div className="progress progress-xs progress-striped">
                    <div className={ProgressClass()} style={{ width: (avg*10)+"%" }}></div>
                </div>
            </td>
            <td >
                <span className={BadgeClass()}>{avg}</span>
            </td>
        </tr>
    )
}
